import React, {
  useRef,
  useState,
  // useEffect
} from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentasBancarias";
import { formatMoneda, formatoMonto, validaMonto } from "../../util/varios";

import {
  DangerButton,
  InfoButton,
  SuccessButton,
} from "../../ui/buttons/Button.jsx";
import { Input, SearchInput } from "../../ui/inputs/Input";

export const ActualizarTransferencias = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  // const idusuario = JSON.parse(localStorage.getItem('idusuario'));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  // const espiritu = JSON.parse(localStorage.getItem('espiritu'));

  const [activate, setActivate] = useState(false);
  const [validacamp, setValidacamp] = useState(false);
  const [validacamp2, setValidacamp2] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [deshabilitado] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState([]);
  const [valmonto, setValmonto] = useState(true);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [opecat, setOpecat] = useState(0);
  const [validabanco, setValidabanco] = useState(0);
  const [validabancob, setValidabancob] = useState(0);
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [idmovorigen, setIdmovorigen] = useState(0);
  const [idmovdestino, setIdmovdestino] = useState(0);
  const [chek1, setChek1] = useState(0);
  const [chek2, setChek2] = useState(0);
  const [chek3, setChek3] = useState(0);
  const [chek4, setChek4] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const txtFecha = useRef();
  const txtMonto = useRef();
  const txtObservacion = useRef();
  // const txtNp = useRef();
  const txtCodigo = useRef();
  const txtMontoOrigen = useRef();
  const txtMontoDestino = useRef();
  const txtCodigoOrigen = useRef();
  const txtCodigoDestino = useRef();
  const txtNomBancoOrigen = useRef();
  const txtNomBancoDestino = useRef();
  const txtNumCuentaOrigen = useRef();
  const txtNumBancoDestino = useRef();
  const txtFechaTransferencia = useRef();
  const txtNumDocumento = useRef();
  const txtFechaReverso = useRef();

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.target.id === "monto") {
        if (
          parseFloat(
            txtMontoOrigen.current.value.replace(/\./g, "").replace(",", ".")
          ) <
          parseFloat(event.target.value.replace(/\./g, "").replace(",", "."))
        ) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡El Monto a Transferir no Debe ser Mayor al Disponible!",
            icono: "error",
          });
          txtMonto.current.value = "";
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCodigoOrigen.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione la Cuenta Origen",
        icono: "informacion",
      });
      sigue = false;
      txtCodigoOrigen.current.focus();
    } else if (txtCodigoDestino.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione la Cuenta Destino",
        icono: "informacion",
      });
      sigue = false;
      txtCodigoDestino.current.focus();
    } else if (txtNumDocumento.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el N° de Documento",
        icono: "informacion",
      });
      sigue = false;
      txtNumDocumento.current.focus();
    } else if (txtFechaTransferencia.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione la Fecha de Transferencia",
        icono: "informacion",
      });
      sigue = false;
      txtFechaTransferencia.current.focus();
    } else if (txtMonto.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Monto a Transferir",
        icono: "informacion",
      });
      sigue = false;
      txtMonto.current.focus();
    } else if (txtObservacion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (sigue) {
      let datos = [];
      // let datost = [];
      let notificacion = [];
      if (operacion === 1) {
        datos.push({
          idtrans: 0,
          ctaorigen: txtCodigoOrigen.current.value,
          ctadestino: txtCodigoDestino.current.value,
          obser: txtObservacion.current.value.trim(),
          tipoo: 16,
          tipod: 17,
          idefi: idefiscal,
          monto: txtMonto.current.value.replace(/\./g, "").replace(",", "."),
          ndocumento: txtNumDocumento.current.value,
          fechatrans: txtFechaTransferencia.current.value,
          fechareal: txtFecha.current.value,
        });
        notificacion.push({
          idtrans: 0,
          numcuentaor: txtNumCuentaOrigen.current.value,
          nomBancoor: txtNomBancoOrigen.current.value.trim(),
          numcuantades: txtNumBancoDestino.current.value,
          nomBancodes: txtNomBancoDestino.current.value.trim(),
          idEfi: idefiscal,
          idasi: "0",
          fechtrans: txtFechaTransferencia.current.value,
          rever: 0,
          idasireve: "0",
          llamado: 4,
          concepto: txtObservacion.current.value.trim(),
        });
      } else if (operacion === 2) {
        datos.push({
          idtrans: txtCodigo.current.value,
          idmovo: idmovorigen,
          idmovd: idmovdestino,
          idefi: idefiscal,
          fechareverso: operacion === 2 ? txtFechaReverso.current.value : "",
          fechatrans: txtFechaTransferencia.current.value,
          numdoc: txtNumDocumento.current.value.trim(),
          obser: txtObservacion.current.value.trim(),
        });
        notificacion.push({
          idtrans: txtCodigo.current.value,
          numcuentaor: txtNumCuentaOrigen.current.value,
          nomBancoor: txtNomBancoOrigen.current.value.trim(),
          numcuantades: txtNumBancoDestino.current.value,
          nomBancodes: txtNomBancoDestino.current.value.trim(),
          idEfi: idefiscal,
          idasi: "0",
          fechtrans: txtFechaTransferencia.current.value,
          rever: 0,
          idasireve: "0",
          llamado: 4,
          concepto: txtObservacion.current.value.trim(),
          fechareverso: operacion === 2 ? txtFechaReverso.current.value : "",
        });
      }
      setBody({
        operacion: operacion,
        origendes: datos,
        notificacion: notificacion,
        idfiscal: idefiscal,
      });
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Realizar esta Transferencia?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Reversar esta Transferencia?.";
      }
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/administracion/crearatransferenciasbancarias`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Transferencia Registrada Correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Transferencia Reversada Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setChek1(0);
    setChek2(0);
    setChek3(0);
    setChek4(0);
    setValida([]);
    setValmonto(true);
    setTip(null);
    setUbi(null);
    setOpecat(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setIdmovdestino(0);
    setIdmovorigen(0);
    setValidabanco(0);
    setValidabancob(0);
    setActivo(true);
    setValidacamp(false);
    setValidacamp2(false);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const catalogoBanco = (op) => (e) => {
    e.preventDefault();
    setOpecat(op);
    setMostrar(true);
    if (op !== 2) {
      setChek1(1);
    } else {
      setChek2(1);
    }
  };
  const handleCancelarBanco = () => {
    setMostrar(false);
    if (chek3 !== 1) {
      setChek1(0);
    } else if (chek4 !== 1) {
      setChek2(0);
    }
  };

  const handleAceptaBanco = (data) => {
    setMostrar(false);
    if (opecat !== 2) {
      setChek3(1);
      if (chek2 === 1) {
        setActivo(false);
      } else {
        setActivo(true);
      }

      if (validabancob === data.idcuentabancaria) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡Esta Cuenta ya fue Seleccionada!",
          icono: "error",
        });
      } else {
        setValidabanco(data.idcuentabancaria);
        setValmonto(false);
        txtCodigoOrigen.current.value = data.idcuentabancaria;
        txtNomBancoOrigen.current.value = data.nombre;
        txtNumCuentaOrigen.current.value = data.cuentabancaria;
        txtMontoOrigen.current.value = formatMoneda(
          data.saldolib.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      }
    } else {
      setChek4(1);
      if (chek1 === 1) {
        setActivo(false);
      } else {
        setActivo(true);
      }
      if (validabanco === data.idcuentabancaria) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡Esta Cuenta ya fue Seleccionada!",
          icono: "error",
        });
      } else {
        setValidabancob(data.idcuentabancaria);
        txtCodigoDestino.current.value = data.idcuentabancaria;
        txtNomBancoDestino.current.value = data.nombre;
        txtNumBancoDestino.current.value = data.cuentabancaria;
        txtMontoDestino.current.value = formatMoneda(
          data.saldolib.toString().replace(",", "").replace(".", ","),
          ",",
          ".",
          2
        );
      }
    }
  };

  const seleccionarBanco = (id, ope) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcuentabancaria > 0) {
            if (ope !== 2) {
              if (chek2 === 1) {
                setActivo(false);
              } else {
                setActivo(true);
              }
              if (validabancob === response.data.idcuentabancaria) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "¡Esta Cuenta ya fue Seleccionada!",
                  icono: "error",
                });
                setValidabanco(0);
                setValmonto(true);
                txtCodigoOrigen.current.value = "";
                txtNomBancoOrigen.current.value = "";
                txtNumCuentaOrigen.current.value = "";
                txtMontoOrigen.current.value = "";
                txtMonto.current.value = "";
              } else {
                setValidabanco(response.data.idcuentabancaria);
                setValmonto(false);
                txtCodigoOrigen.current.value = response.data.idcuentabancaria;
                txtNomBancoOrigen.current.value = response.data.nombre;
                txtNumCuentaOrigen.current.value = response.data.cuentabancaria;
                txtMontoOrigen.current.value = formatMoneda(
                  response.data.saldolib
                    .toString()
                    .replace(",", "")
                    .replace(".", ","),
                  ",",
                  ".",
                  2
                );
              }
            } else {
              if (chek1 === 1) {
                setActivo(false);
              } else {
                setActivo(true);
              }
              if (validabanco === response.data.idcuentabancaria) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",
                  texto: "¡Esta Cuenta ya fue Seleccionada!",
                  icono: "error",
                });
                setValidabancob(0);
                txtCodigoDestino.current.value = "";
                txtNomBancoDestino.current.value = "";
                txtNumBancoDestino.current.value = "";
                txtMontoDestino.current.value = "";
              } else {
                setValidabancob(response.data.idcuentabancaria);
                txtCodigoDestino.current.value = response.data.idcuentabancaria;
                txtNomBancoDestino.current.value = response.data.nombre;
                txtNumBancoDestino.current.value = response.data.cuentabancaria;
                txtMontoDestino.current.value = formatMoneda(
                  response.data.saldolib
                    .toString()
                    .replace(",", "")
                    .replace(".", ","),
                  ",",
                  ".",
                  2
                );
              }
            }
          } else {
            setChek1(0);
            setChek2(0);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "¡Cuenta Bancaria no Registrada!",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "No existe un Fondo de Tercero con este codigo",
          icono: "informacion",
        });
      });
  };

  const seleccionarBancouno = (id) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcuentabancaria > 0) {
            txtCodigoOrigen.current.value = response.data.idcuentabancaria;
            txtNomBancoOrigen.current.value = response.data.nombre;
            txtNumCuentaOrigen.current.value = response.data.cuentabancaria;
            txtMontoOrigen.current.value = formatMoneda(
              response.data.saldolib
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "¡Cuenta Bancaria no Registrada!",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
      });
  };

  const seleccionarBancodos = (id) => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idcuentabancaria > 0) {
            txtCodigoDestino.current.value = response.data.idcuentabancaria;
            txtNomBancoDestino.current.value = response.data.nombre;
            txtNumBancoDestino.current.value = response.data.cuentabancaria;
            txtMontoDestino.current.value = formatMoneda(
              response.data.saldolib
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "¡Cuenta Bancaria no Registrada!",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
      });
  };

  const handleBanco = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof e.which === "undefined") {
      if (e.target.value !== "") {
        if (e.target.name === "origen") {
          seleccionarBanco(e.target.value, 1);
          setChek1(1);
        } else if (e.target.name === "destino") {
          seleccionarBanco(e.target.value, 2);
          setChek2(1);
        }
      }
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          if (props.operacion === 2) {
            setActivo(false);
          } else {
            setActivo(true);
          }
          if (props.movimientos.length > 0) {
            setChek1(1);
            setChek2(1);
            seleccionarBancodos(props.movimientos[0].idcuentadestino);
            seleccionarBancouno(props.movimientos[0].idcuentaorigen);
            setIdmovorigen(props.movimientos[0].idmoviorigen);
            setIdmovdestino(props.movimientos[0].idmovidestino);
          } else {
            setChek1(0);
            setChek2(0);
          }
        } else {
          txtObservacion.current.value = "";
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtFechaTransferencia.current.value =
            moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtCodigo.current.value = "";
          txtNumDocumento.current.value = "";
          txtMonto.current.value = "";
        }
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>
          {operacion === 4
            ? "Consulta. Transferencia Bancaria"
            : operacion === 2
            ? "Reversar Transferencia Bancaria"
            : operacion === 3
            ? "Transferencia Bancaria"
            : "Transferencia Bancaria"}
        </h3>
        <a type="button" onClick={cancelar}>
          salir <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <CatalogoCuentaBancaria
          show={mostrar}
          onHideCancelar={handleCancelarBanco}
          onHideAceptaCatalogo={handleAceptaBanco}
        />
        <Dimmer active={activate} inverted></Dimmer>
        {/* <input type='hidden' ref={txtNp} /> */}
        <fieldset
          style={{ height: "300px", overflowY: "auto" }}
          className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap align-items-center"
        >
          <legend className="float-none m-0 w-auto">Datos</legend>
          <div className="col-3 col-lg-2 p-0 m-0">
            <Input
              label="Código:"
              name="observacion"
              disabled={true}
              defaultValue={
                props.transferencia
                  ? props.transferencia.idtransferenciabancaria
                  : ""
              }
              id="inputDireccion"
              ref={txtCodigo}
            />
          </div>
          {operacion === 2 && (
            <div className="col-3 m-0 p-0">
              <Input
                label="Fecha Reverso:"
                type="date"
                defaultValue={moment.utc(fechaSistema).format("YYYY-MM-DD")}
                id="inputDireccion"
                ref={txtFechaReverso}
              />
            </div>
          )}
          <div className="col-9 col-lg-2 p-0 m-0 ml-lg-auto">
            <Input
              type="date"
              disabled={true}
              defaultValue={
                props.transferencia && props.transferencia.fechareal !== ""
                  ? moment.utc(props.transferencia.fechareal).format("YYYY-MM-DD")
                  : moment.utc(fechaSistema).format("YYYY-MM-DD")
              }
              id="inputDireccion"
              ref={txtFecha}
            />
          </div>
          <fieldset className="col-12 border-azul rounded m-0 d-flex flex-wrap">
            <legend className="float-none m-0 w-auto fw-bold fs-6">
              N° de Cuenta Origen
            </legend>
            <div className="col-4 col-lg-2 input-group input-group-sm m-0 p-0">
              <SearchInput
                label="Código:"
                disabled={
                  operacion === 4 || operacion === 2 ? true : deshabilitado
                }
                onKeyUp={handleBanco}
                name="origen"
                id="inputDireccion"
                onClickButton={catalogoBanco(1)}
                disabledButton={
                  operacion === 4 || operacion === 2 ? true : deshabilitado
                }
                ref={txtCodigoOrigen}
              />
            </div>
            <div className="col-12 col-lg-6 m-0 my-2 my-lg-0 p-0 px-lg-2">
              <Input
                label="Banco:"
                disabled={true}
                name="observacion"
                id="inputDireccion"
                ref={txtNomBancoOrigen}
              />
            </div>
            <div className="col-12 col-lg-4 m-0 p-0">
              <Input
                label="N° de Cuenta:"
                disabled={true}
                name="observacion"
                id="inputDireccion"
                ref={txtNumCuentaOrigen}
              />
            </div>
            {chek1 === 1 && (
              <div className="col-7 col-lg-3 m-0 ml-auto mt-2 p-0">
                <Input
                  label="Monto Disponible:"
                  inputClassName="text-end"
                  disabled={true}
                  name="observacion"
                  id="inputDireccion"
                  ref={txtMontoOrigen}
                />
              </div>
            )}
          </fieldset>
          <fieldset className="col-12 border-azul rounded d-flex flex-wrap mb-2">
            <legend className="float-none m-0 w-auto fw-bold fs-6">
              N° de Cuenta Destino
            </legend>
            <div className="col-4 col-lg-2 m-0 p-0">
              <SearchInput
                label="Código:"
                disabled={
                  operacion === 4 || operacion === 2 ? true : deshabilitado
                }
                onKeyUp={handleBanco}
                name="destino"
                id="inputDireccion"
                disabledButton={
                  operacion === 4 || operacion === 2 ? true : deshabilitado
                }
                onClickButton={catalogoBanco(2)}
                ref={txtCodigoDestino}
              />
            </div>
            <div className="col-12 col-lg-6 m-0 my-2 my-lg-0 p-0 px-lg-2">
              <Input
                label="Banco:"
                disabled={true}
                name="observacion"
                id="inputDireccion"
                ref={txtNomBancoDestino}
              />
            </div>
            <div className="col-12 col-lg-4 m-0 p-0">
              <Input
                label="N° de Cuenta:"
                disabled={true}
                name="observacion"
                id="inputDireccion"
                ref={txtNumBancoDestino}
              />
            </div>
            {chek2 === 1 && (
              <div className="col-7 col-lg-3 p-0 m-0 ml-auto mt-2">
                <Input
                  label="Monto Disponible:"
                  inputClassName="text-end"
                  disabled={true}
                  name="observacion"
                  id="inputDireccion"
                  ref={txtMontoDestino}
                />
              </div>
            )}
          </fieldset>

          <div className="col-12 col-lg-4 m-0 mb-2 mb-lg-0 p-0">
            <Input
              label="N° de Documento:"
              disabled={
                operacion === 4 || operacion === 2 ? true : deshabilitado
              }
              name="observacion"
              defaultValue={
                props.transferencia ? props.transferencia.ndocumento : ""
              }
              id="inputDireccion"
              ref={txtNumDocumento}
            />
          </div>
          <div className="col-12 col-lg-4 m-0 mb-2 mb-lg-0 p-0 px-lg-2">
            <Input
              label="Fecha de Transferencia:"
              type="date"
              disabled={
                operacion === 4 || operacion === 2 ? true : deshabilitado
              }
              defaultValue={
                props.transferencia && props.transferencia.fechamov !== ""
                  ? moment.utc(props.transferencia.fechamov).format("YYYY-MM-DD")
                  : moment.utc(fechaSistema).format("YYYY-MM-DD")
              }
              id="inputDireccion"
              ref={txtFechaTransferencia}
            />
          </div>

          <div className="col-12 col-lg-4 m-0 p-0">
            <Input
              label="Monto a Transferir:"
              disabled={valmonto}
              onBlur={handleInputMontoChange}
              onKeyUp={handleInputMontoChange}
              placeholder="0,00"
              name="monto"
              defaultValue={
                props.transferencia
                  ? formatMoneda(
                      props.transferencia.monto
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                      ",", ".", 2
                    )
                  : ""
              }
              id="monto"
              ref={txtMonto}
              inputClassName='text-end'
            />
          </div>
          <div className="col-12 m-0 mt-2 p-0">
            <Input label = 'Observación:'
              name="observacion"
              onChange={onChange}
              disabled={operacion === 4 || operacion === 2 ? true : false}
              defaultValue={
                props.transferencia
                  ? props.transferencia.observaciones.trim()
                  : ""
              }
              placeholder="Descripción de la Observación"
              id="inputDireccion"
              ref={txtObservacion}
            />
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer className="footer-azulGradiant">
        {operacion === 4 ? (
          <InfoButton icon="fa-print">Imprimir</InfoButton>
        ) : (
          <SuccessButton onClick={onChangeValidar} disabled={activo}>
            Aceptar
          </SuccessButton>
        )}
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
